import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { Center } from "../models/center.model";
import { CenterData } from "../models/center-data.model";
import { CenterFormFilter } from "../models/center-form-filter.model";

export namespace CenterActions {

  @logDispatcher
  export class GetCenters {
    static readonly type = '[Center] GetCenters';
    constructor() {}
  }

  @logDispatcher
  export class GetCentersSuccess {
    static readonly type = '[Center] GetCentersSuccess';
    constructor(public centers: CenterData[]) {}
  }

  @logDispatcher
  export class GetCenterDetails {
    static readonly type = '[Center] GetCenterDetails';
    constructor(public centerCode: string) { }
  }

  @logDispatcher
  export class GetCenterDetailsSuccess {
    static readonly type = '[Center] GetCenterDetailsSuccess';
    constructor(public center: CenterData) { }
  }

  @logDispatcher
  export class GetCentersMap {
    static readonly type = '[Center] GetCentersMap';
    constructor(public user: string, public zoneId: number) {}
  }

  @logDispatcher
  export class GetCentersMapSuccess {
    static readonly type = '[Center] GetCentersMapSuccess';
    constructor(public centers: Center[]) {}
  }

  @logDispatcher
  export class GetCentersByUserAndExerciseMap {
    static readonly type = '[Center] GetCentersByUserAndExerciseMap';
    constructor(public user: string, public exerciseId: number, public filters: CenterFormFilter) {}
  }

  @logDispatcher
  export class GetCentersByUserAndExerciseMapSuccess {
    static readonly type = '[Center] GetCentersByUserAndExerciseMapSuccess';
    constructor(public centers: Center[]) {}
  }

  @logDispatcher
  export class AddCenter {
    static readonly type = "[Center] AddCenter"
    constructor(public center: CenterData, public user: string) {}
  }

  @logDispatcher
  export class AddCenterSuccess {
    static readonly type = '[Center] AddCenterSuccess';
    constructor(public center: CenterData) {}
  }

  @logDispatcher
  export class EditCenter {
    static readonly type = '[Center] EditCenter';
    constructor(public center: CenterData, public user: string) {}
  }

  @logDispatcher
  export class EditCenterSuccess {
    static readonly type = '[Center] EditCenterSuccess';
    constructor(public center: CenterData) {}
  }

  @logDispatcher
  export class Error {
    static readonly type = '[Center] Error';
    constructor(public error: any, public details: string) {}
  }

  @logDispatcher
  export class SetIsListSmaller {
    static readonly type = '[Center] SetIsListSmaller';
    constructor(public isListSmaller: boolean) {}
  }

  @logDispatcher
  export class SetCenterDefaultState  {
      static readonly type = '[Center] SetCenterDefaultState';
      constructor() {}
  }

  @logDispatcher
  export class SetCenterDefaults  {
      static readonly type = '[Center] SetCenterDefaults';
      constructor() {}
  }
}
